import { createFormatters } from '../formatters';

/**
 * Formateadores por defecto del panel de Instrumento Financiero. El consumidor
 * puede sobrescribirlos por props (`formatAmount` / `formatDate`).
 *
 * Son funciones puras (no pueden usar el hook `useMasterDocumentFormatters`),
 * por eso reciben el `locale` como parámetro opcional en vez de resolverlo
 * ellas mismas; el componente que las consume debe pasarle el `locale` del
 * idioma activo (`useMasterDocumentFormatters().locale`).
 */

/** Monto con 2 decimales, según el `locale` dado. */
export const defaultFormatAmount = (value: number, locale: string = 'es-CO'): string =>
  createFormatters(locale).formatAmount(value);

/**
 * Fecha (`YYYY-MM-DD` o cualquier valor que `Intl` entienda) según el `locale`
 * dado: `15/07/2026` en español, `Jul 15, 2026` en inglés.
 *
 * Antes construía `dd/MM/yyyy` por partes, justificándolo con que ese formato
 * "no varía con el idioma". Eso era precisamente el defecto: `01/09/2026` se lee
 * como 1 de septiembre en español y como 9 de enero en inglés, así que la cadena
 * fija no es neutra, es ambigua. Dejaba además a dos paneles del mismo feature
 * con dos comportamientos, porque `InstallmentsPanel` sí usa el hook de
 * formateadores.
 *
 * El motivo real de la construcción manual era el desfase de zona horaria
 * (`new Date('YYYY-MM-DD')` interpreta UTC y al oeste de Greenwich retrocede un
 * día); `createFormatters` ya lo resuelve parseando la fecha en horario local.
 *
 * Ante fecha ausente o inválida devuelve el guion largo del resto del kit —antes
 * devolvía cadena vacía o el valor crudo—, para que el FactBox no muestre un
 * "Vence" sin nada detrás.
 */
export const defaultFormatDate = (isoDate: string, locale: string = 'es-CO'): string =>
  createFormatters(locale).formatDate(isoDate);
